import ProducerDetail from "./ProducerDetail";
import NomeclatureFilters from "./NomeclatureFilters";
import SeriesDetail from "./SeriesDetail";

export const Availability = {
  Series: SeriesDetail,
  Procuer: ProducerDetail,
  NomenclatureFilters: NomeclatureFilters
}